import {observer} from "mobx-react";
import React from "react";
import {useInjection} from "inversify-react";
import {AppController} from "@dropDesk/presentation/app/app.controller";
import DropDeskIcon from "@dropDesk/storage/icons";
import {ICONS_DROPDESK} from "@dropDesk/storage/icons/icons.d";
import {hexToRGBA} from "@dropDesk/utils/helpers/colors";
import {Banner, BannerContent, BannerText, BannerTitle, IconCircle} from "./styled";

const SummaryBanner = observer(({
    summary,
    title = 'Resumo',
}: {
    summary: string;
    title?: string;
}) => {
    const appController = useInjection(AppController);
    const colors = appController.theme.colorScheme;

    if (!summary) {
        return null;
    }

    return (
        <Banner
            background={hexToRGBA(colors.accent, 0.08)}
            border={hexToRGBA(colors.accent, 0.2)}
        >
            <IconCircle background={hexToRGBA(colors.accent, 0.18)}>
                <DropDeskIcon icon={ICONS_DROPDESK.dashboard} size={22} color={colors.accent}/>
            </IconCircle>
            <BannerContent>
                <BannerTitle color={colors.text}>{title}</BannerTitle>
                <BannerText color={colors.hintInverse}>{summary}</BannerText>
            </BannerContent>
        </Banner>
    );
});

export default SummaryBanner;
